import { render, staticRenderFns } from "./website-testimonial.vue?vue&type=template&id=6164ad0d&scoped=true&"
import script from "./website-testimonial.vue?vue&type=script&lang=js&"
export * from "./website-testimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6164ad0d",
  null
  
)

export default component.exports